import React, { useState } from "react";
import { getSecondsAndMinutes } from "../../utils/converters/time-helper";
import SvgIcon from "../SvgIcon";

const TimeSelector = ({ onChange = () => {}, restTime }) => {
  const [isListOpen, setIsListOpen] = useState(false);
  const [secs, mins] = getSecondsAndMinutes(restTime);
  const [minutes, setMinutes] = useState(mins);
  const [seconds, setSeconds] = useState(secs);

  const handleMinutesChange = (value) => {
    if (!value) return setMinutes("");
    let newMinutes = parseInt(value, 10);

    if (isNaN(newMinutes)) {
      setMinutes(0);
    }
    if (!isNaN(newMinutes) && newMinutes >= 0 && newMinutes <= 60) {
      let newSeconds = seconds;
      setMinutes(newMinutes);

      if (newMinutes === 60) {
        newSeconds = 0;
        setSeconds(newSeconds);
      }
    }
  };

  const handleSecondsChange = (value) => {
    if (!value) return setSeconds("");
    let newSeconds = parseInt(value, 10);

    if (isNaN(newSeconds)) {
      setSeconds(0);
    }

    if (!isNaN(newSeconds) && newSeconds >= 0 && newSeconds <= 60) {
      if (minutes < 60 || (minutes === 60 && newSeconds === 0)) {
        setSeconds(newSeconds);
      }
    }
  };

  const toggleList = (e) => {
    e.preventDefault();
    setIsListOpen((prevState) => !prevState);
    if (seconds > 0 || minutes > 0) {
      onChange({
        target: { name: "restTime", value: seconds + minutes * 60 },
      });
    }
  };

  return (
    <fieldset className="time-selector">
      <button onClick={toggleList} data-button-type="secondary" tabIndex="-1">
        <SvgIcon src="/img/svg/time.svg" />
      </button>
      {isListOpen && (
        <div className="time-selector-body">
          <label htmlFor="default-time-minutes" className="!mb-0">
            Custom rest time
          </label>

          <div className="default-time-select-row">
            <div className="default-time-row">
              <input
                className="text-center"
                type="number"
                id="default-time-minutes"
                name="default-time-minutes"
                min="0"
                max="60"
                value={minutes}
                onChange={(e) => {
                  handleMinutesChange(e.target.value);
                }}
              />
              Min
            </div>
            <span className="time-separator">:</span>
            <div className="default-time-row">
              <input
                className="text-center"
                type="number"
                id="default-time-seconds"
                name="default-time-seconds"
                min="0"
                max="60"
                value={seconds}
                onChange={(e) => {
                  handleSecondsChange(e.target.value);
                }}
              />
              Sec
            </div>
          </div>
          <button data-button-type="primary" onClick={toggleList}>
            Save
          </button>
        </div>
      )}
    </fieldset>
  );
};

export default TimeSelector;
